'use client';
import { Select as ChakraSelect, Icon, forwardRef } from '@chakra-ui/react';
import React from 'react';
import { ChevronDown } from '../../icons';
export const Select = forwardRef((props, ref)=>{
    const { children , isInvalid , isDisabled , ...selectProps } = props;
    let iconColor;
    if (isInvalid) {
        iconColor = 'stroke.error';
    } else if (isDisabled) {
        iconColor = 'stroke.light';
    } else {
        iconColor = 'stroke.interactive';
    }
    return /*#__PURE__*/ React.createElement(ChakraSelect, {
        icon: /*#__PURE__*/ React.createElement(Icon, {
            as: ChevronDown,
            stroke: iconColor
        }),
        iconSize: "24px",
        isInvalid: isInvalid,
        ref: ref,
        ...selectProps
    }, children);
});

//# sourceMappingURL=select.js.map